// @flow
import {
  GET_BILLING_COMPANY,
  GET_CURRENT_BILLING,
  GET_HISTORY_BILLINGS,
  GET_HISTORY_BILLING_DETAIL
} from "../../global/actions/actionNames";

const initialState: * = {
  company: null,
  currentBilling: null,
  historyBillings: null
};

const billingReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case GET_BILLING_COMPANY:
      if (actions.company !== undefined) {
        return {
          ...state,
          company: actions.company
        };
      }
      return state;

    case GET_CURRENT_BILLING:
      if (actions.currentBilling !== undefined) {
        return {
          ...state,
          currentBilling: actions.currentBilling
        };
      }
      return state;

    case GET_HISTORY_BILLINGS:
      if (actions.historyBillings !== undefined) {
        return {
          ...state,
          historyBillings: actions.historyBillings
        };
      }
      return state;

    case GET_HISTORY_BILLING_DETAIL:
      if (actions.billindId !== undefined && actions.logs !== undefined) {
        let historyBillings = [...state.historyBillings];
        let index = historyBillings.findIndex(x => x.id === actions.billindId);
        if (index > -1) {
          let billing = { ...historyBillings[index] };
          billing.logs = [...actions.logs];

          historyBillings[index] = billing;
          return {
            ...state,
            historyBillings: historyBillings
          };
        }
      }
      return state;

    default:
      return state;
  }
};

export default billingReducers;
